import React from 'react';
import styled from 'styled-components';

import { BLUE_GREY } from '../../../theme';
import media from '../../../utils/mediaQueries';

const Container = styled.div`
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: ${BLUE_GREY};

  ${media.mobile`
    margin-top: 24px;
  `}
`;

const Italic = styled.i`
  font-style: italic;
`;

const Footnote = () => (
  <Container>
    Les données de ce formulaire font l’objet de traitements dont le responsable est Vroom France - 13 rue Olier 75015 Paris.
    Elles sont utilisées pour la collecte, la modération et la diffusion des avis et le respect par Vroom France de ses obligations légales.
    Elles sont conservées pour une durée maximale de cinq (5) ans. Vous disposez d’un droit d’accès, de rectification, de limitation, de portabilité,
    d’opposition, de suppression et vous pouvez définir des directives
    <Italic> post mortem </Italic>
    relatives à vos données. Vous pouvez exercer vos droits en envoyant un email à
    {' '}
    <a href="mailto:contact@vroomvroom.fr">contact@vroomvroom.fr</a>
    {' '}
    ou en contactant le Délégué à la protection des données de Vroom France. Pour en savoir plus, vous pouvez consulter notre
    {' '}
    <a href="/a-propos/donnees-personnelles" target="_blank" rel="noopener noreferrer">
      politique de protection des données.
    </a>
  </Container>
);

export { Footnote };
